import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Alert, Collapse, Row, Col } from 'react-bootstrap';
import { Form } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim, LodgeButtonLoadingRing } from '../../GeneralStyle'
import Parse from 'parse'

import { requiredFields as companyRequiredFields } from './CompanyForm';
import { requiredFields as userRequiredFields } from './MemberForm';

import MemberInputs from './Inputs/MemberInputs'
import CompanyInputs from './Inputs/CompanyInputs';

@inject('adminStore')

@observer
class CreateCompanyAndMember extends Component {

    async componentDidUpdate(prevProps) {
      if (prevProps.application != this.props.application) {
        const application = this.props.application

        await this.setState({
          partner: {
            name: application ? application.company : "",
            contactEmail: application ? application.email : "",
            uidNumber: application ? application.uid : "",
            industry: application ? application.industry : "",
            phone: application ? application.phone : "",
            postcode: application ? application.postcode : "",
            street: application ? application.address : "",
            location: application ? application.city : "",
            region: application ? application.region : "",
            // vat: 0.2,
            maxBookingCount: 120,
            maxRemainingStockBookingCount: 0,
            shortname: application ? application.company.toLowerCase().replace(/ /g, "") : ""
          },
          user: {
              firstname: application ? application.firstname : "",
              lastname: application ? application.lastname : "",
              title: application ? application.title : "",
              phone: application ? application.phone : "",
              email: application ? application.email : "",
              position: application ? application.position : "",
              homeGolfCourse: application ? application.golfcourse : "",
              handicap: application ? application.handicap : "",
              birthday: application ? application.birthdate : "",
          },
        })
        this.findSortingNumber()

      }
    }

    constructor(props) {
        super(props)

        const application = props.application

        this.state = {
            showAlert: false,
            step: 0,

            companyImage: null,
            memberImage: null,

            imageUploading: false,
            imageUploaded: false,

            isLoading: false,
            loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
            buttonText: 'SPEICHERN',

            partner: {
                name: application ? application.company : "",
                contactEmail: application ? application.email : "",
                uidNumber: application ? application.uid : "",
                industry: application ? application.industry : "",
                region: application ? application.region : "",
                // vat: 0.2,
                maxBookingCount: 120,
                maxRemainingStockBookingCount: 0,
                shortname: application ? application.company.toLowerCase().replace(/ /g, "") : ""
            },

            user: {
                firstname: application ? application.firstname : "",
                lastname: application ? application.lastname : "",
                title: application ? application.title : "",
                phone: application ? application.phone : "",
                email: application ? application.email : "",
                position: application ? application.position : "",
                homeGolfCourse: application ? application.golfcourse : "",
                handicap: application ? application.handicap : 0,
            },

            contract: {
                fee: undefined,
                year: (new Date).getFullYear()+1
            },

            error: null,
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.updateStates = this.updateStates.bind(this)

        this.findSortingNumber()
    }

    findSortingNumber = () => {
      if(this.state.partner.sortingNumber)
        return

      const companyQuery = new Parse.Query("Company")
      companyQuery.descending("sortingNumber")
      companyQuery.lessThanOrEqualTo("sortingNumber", 9000)

      companyQuery.first().then(res => {
        this.setState({ partner: {...this.state.partner, sortingNumber: res.get("sortingNumber") + 1} })
      })
    }

    // Reset button when form changes
    updateStates = () => {
        this.setState({
            isLoading: false,
            loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
            buttonText: 'SPEICHERN',
        })
    }

    onSubmit = () => {
        this.setState({
            isLoading: true
        })

        const company = this.state.partner
        const user = this.state.user

    		if(!user.handicap) user.handicap = 0

        // Setting new image identifier if new image has been added
        company.logo = (this.state.companyImage !== null ? this.state.companyImage : company.logo)
        user.profileImage = (this.state.memberImage !== null ? this.state.memberImage : user.profileImage)

        Parse.Cloud.run("addCompanyWithUser", { company: { ...company, region: company.region.slug && company.region.slug }, user, createContact: true, contractFee: this.state.contract.fee, year: this.state.contract.year })
            .then(result => {
                // Setting states for proper button rendering
                this.setState({
                    isLoading: false,
                    loadingState: 1,
                    buttonText: 'GESPEICHERT'
                })

        				setTimeout(() => {
        					this.props.history.push("/internal/admin/members")
        				}, 1.5*1000);
            })
            .catch(error => {
                // Setting states for proper button rendering
                this.setState({
                    isLoading: false,
                    loadingState: 2,
                    buttonText: 'ERNEUT',
                    error: error.message.message
                })
                console.error("error", error)
            })
    }

    render() {

        const isButtonDisabled = () => {
            // Use HTML validation for now
            return false

            const partner = this.state.partner;
            const contract = this.state.contract;

            if (!partner.objectId && (contract.fee == null || contract.fee === ""))
                return true

            for (let item of companyRequiredFields) {
                if (partner[item] === "" || partner[item] == null) {
                    return true
                }
            }

            const user = this.state.user;

            for (let item of userRequiredFields) {
                if (user[item] === "" || user[item] == null) {
                    return true
                }
            }

            // Check If Mail is Valid
            // partner["email"] should only be tested if not empty

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (
                partner["email"] && partner["contactEmail"] && user["email"] && (
                !re.test(String(partner["email"]).toLowerCase()) ||
                !re.test(String(partner["contactEmail"]).toLowerCase()) ||
                !re.test(String(user["email"]).toLowerCase())
                )
            )
                return true

            return false
        }

        const isFirstStepDisabled = () => {
          const partner = this.state.partner;
          const contract = this.state.contract;

          for (let item of companyRequiredFields) {
              if (partner[item] === "" || partner[item] == null) {
                  return true
              }
          }

          let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (
            partner["email"] && partner["contactEmail"] && (
              !re.test(String(partner["email"]).toLowerCase()) ||
              !re.test(String(partner["contactEmail"]).toLowerCase())
            )
          )
            return true

          return false
        }

        const isSecondStepDisabled = () => {
          const user = this.state.user;

          for (let item of userRequiredFields) {
              if (user[item] === "" || user[item] == null) {
                  return true
              }
          }

          // Check If Mail is Valid
          // partner["email"] should only be tested if not empty

          let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (
              user["email"] && !re.test(String(user["email"]).toLowerCase())
          )
              return true

          return false
        }

        return (
          <ContainerBox style={{maxWidth: 1200, margin: "20px auto"}}>
            <Row style={{ paddingTop: 25, margin: 'auto' }}>
              <Form
              className={'dashboard-form'}
              onSubmit={this.onSubmit}
              onChange={this.updateStates}
              layout={'vertical'}
              validatePristine={true}
              disabled={this.state.loadingState === 1}
              >
              { this.state.step !== 1 &&
                <div>
                <Col md={12}>
                  <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                      Unternehmensdaten angeben: (Schritt 1/2)
                  </Heading>
                </Col>

                <CompanyInputs onChange={(state) => this.setState(state)} data={this.state.partner} requiredFields={companyRequiredFields} contract={this.state.contract} />
                </div>
              }

              { this.state.step === 1 &&
                <div>
                <Col md={12}>
                  <Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
                      Mitgliedsdaten angeben: (Schritt 2/2)
                  </Heading>
                </Col>

                <MemberInputs onChange={(state) => this.setState(state)} data={this.state.user} requiredFields={userRequiredFields} hide={["CompanySelect"]} />
                </div>
              }
              </Form>
              <Col md={12} style={{textAlign: "center", paddingBottom: 45}}>
              { this.state.step === 0 &&
                <LogeButtonSlim
                    style={{
                        position: 'relative',
                        display: 'inline-flex',
                        margin: 'auto !important',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#FFF',
                    }}
                    hoverFontColor={"white"}
                    onClick={() => {this.setState({step: 1}); window.scrollTo({top: 0, behavior: 'smooth'}); }}
                    disabled={ isFirstStepDisabled() }
                >
                  nächster Schritt
                </LogeButtonSlim>
              }
              { this.state.step === 1 &&
                <div>
                <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LogeButtonSlim
                    style={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#FFF',
                    }}
                    hoverFontColor={"white"}
                    onClick={() => {this.setState({step: 0}); window.scrollTo({top: 0, behavior: 'smooth'});}}
                >
                  Schritt zurück
                </LogeButtonSlim>
                </Col>
                <Col md={6} style={{ display: 'flex', justifyContent: 'flex-start' }}>

                <p style={{
                  position: 'absolute',
                  display: 'inline-block',
                  left: 0,
                  transform: "translateX(-50%)",
                  top: 14,
                  /* Conditional rendering of text according to loadingState */
                  transform: this.state.loadingState !== 0 ? (this.state.loadingState === 1 ? 'translateY(95px)' : 'translateY(50px)') : 'none',
                  color: this.state.loadingState === 2 ? 'rgb(217, 83, 79)' : '#DAB777',
                }}>
                  {this.state.loadingState === 0 ? "" : (this.state.loadingState === 1 ? 'Erfolgreich angelegt' : this.state.error)}
                </p>

                <LodgeButtonLoadingRing style={{ transform: this.state.isLoading ? 'translateX(135px)' : 'none', opacity: this.state.isLoading ? 1 : 0, margin: 0 }}></LodgeButtonLoadingRing>
                <LogeButtonSlim
                  style={{
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#FFF',
                  }}
                  disabled={ isButtonDisabled() }
                  hoverFontColor={"white"}
                  onClick={this.onSubmit}
                  // Conditional rendering of button according to loadingState
                  {...(this.state.loadingState === 2 ? { color: 'rgb(217, 83, 79)', fontColor: 'rgb(217, 83, 79)' } : {})}
                >
                  {this.state.buttonText}
                </LogeButtonSlim>
                </Col>
                </div>
              }
              </Col>
            </Row>
          </ContainerBox>
        )
    }
}

CreateCompanyAndMember.propTypes = {
    userStore: MobxPropTypes.observableObject,
    cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(CreateCompanyAndMember));



// WEBPACK FOOTER //
// /src/components/admin/Forms/CreateCompanyAndMemberForm.js